// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"5f7ee737","247":"c6083c2f","284":"142c4776","348":"7a8efaa6","388":"c575baf4","627":"37958536","867":"7c942a5a","923":"153fedc2","938":"78b92e44"}[chunkId] + ".chunk.js";
};